export default class ListValidationException extends Error {
  public name: string;

  constructor(list: string) {
    super(`List ${list} doesnt exist`);
    this.name = 'ListValidationException';
  }
}
